import { Expose, Type } from 'class-transformer'
import { CardString } from 'pokersolver'

import type { PlayerState } from '../model'
import { BotKind, PlayerKind, PlayerStates } from '../model'
import { Player } from '../model/Player'

export class PlayerEntity {
  /**
   * Player unique id
   */
  @Expose()
  public id: string

  /**
   * Player name
   */
  @Expose()
  public name: string

  /**
   * Player userId
   */
  @Expose()
  public userId?: string

  /**
   * Player userRoles
   */
  @Expose()
  @Type(() => String)
  public userRoles?: string[]

  /**
   * Player current chips in stack
   */
  @Expose()
  public chips: number

  /**
   * Player current hole cards
   */
  @Expose()
  @Type(() => String)
  public cards: CardString[]

  /**
   * Player current state
   */
  @Expose()
  public state: PlayerState

  @Expose()
  public kind: PlayerKind

  @Expose()
  public botKind?: BotKind

  /**
   * Player cards visibility for teacher
   */
  @Expose()
  public isCardsVisibleByTeacher?: boolean

  /**
   * Player cards visibility for teacher
   */
  @Expose()
  public isCardsVisibleByEveryone?: boolean

  /**
   * Default PlayerEntity
   * @param partial PlayerEntity to construct from partial
   */
  constructor(partial: Partial<PlayerEntity>) {
    this.id = ''
    this.name = ''
    this.chips = 0
    this.cards = []
    this.state = PlayerStates.InPlay
    this.kind = PlayerKind.HUMAN
    Object.assign(this, partial)
  }

  /**
   * Creates a new PlayerEntity from the given reference player
   *
   * @param player reference player to make entity
   * @returns
   */
  static createFromPlayer(player: Player) {
    if (!player) {
      return
    }

    return <PlayerEntity>{
      id: player.getId(),
      name: player.name,
      userId: player.userId,
      userRoles: player.userRoles,
      chips: player.chips,
      cards: player.showCards(),
      state: player.state,
      botKind: player.botKind,
      isCardsVisibleByTeacher: player.isCardsVisibleByTeacher,
      isCardsVisibleByEveryone: player.isCardsVisibleByEveryone
    }
  }
}
